// src/plugins/vuetify.js
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import {en, he, pt} from "vuetify/es5/locale";

let lang = document.documentElement.lang;
Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  lang: {
    locales: {he, en, pt},
    current: lang,
  },
  rtl: lang === "he"

});
